import {
  LayoutGeometryHelper as G,
  type NodeFrame,
} from './layout-geometry-helper';
import type { PlacedNode, UnlinkedTray } from './structure-layout.types';
import { TextMeasureHelper, type TextMeasurer } from './text-measure-helper';

class TrayHelper {
  static readonly COLUMNS = 3;

  static readonly COLUMN_GAP = 32;

  static readonly ROW_GAP = 24;

  static readonly HEADING_HEIGHT = 24;

  static readonly HEADING_GAP = 12;

  static readonly HEADING_FONT = `500 13px ${TextMeasureHelper.FONT_FAMILY}`;

  static getHeadingText(count: number): string {
    return `Unlinked entities ${count}`;
  }

  static layout(
    entityIds: ReadonlyArray<number>,
    origin: Readonly<{ x: number; y: number }>,
    measurer: Readonly<TextMeasurer>,
    frame: Readonly<NodeFrame> = G.CARD_FRAME
  ): { tray: UnlinkedTray; nodes: PlacedNode[] } | null {
    if (entityIds.length === 0) return null;
    const text = TrayHelper.getHeadingText(entityIds.length);
    const nodesTop =
      origin.y + TrayHelper.HEADING_HEIGHT + TrayHelper.HEADING_GAP;
    const nodes = entityIds.map((entityId, i) => ({
      entityId,
      x:
        origin.x +
        (i % TrayHelper.COLUMNS) * (frame.width + TrayHelper.COLUMN_GAP),
      y:
        nodesTop +
        Math.floor(i / TrayHelper.COLUMNS) *
          (frame.height + TrayHelper.ROW_GAP),
      width: frame.width,
      height: frame.height,
    }));
    return {
      tray: {
        heading: {
          text,
          x: origin.x,
          y: origin.y,
          width: Math.ceil(measurer.measure(text, TrayHelper.HEADING_FONT)),
          height: TrayHelper.HEADING_HEIGHT,
        },
        entityIds: [...entityIds],
      },
      nodes,
    };
  }
}

export { TrayHelper };
